import { v4 as uuidv4 } from "uuid";

export function generateId() {
  return uuidv4();
}

export function formatCentsAsMoney(cents: number) {
  const locale = window.SHOPIFY_DATA.shop.locale;
  const country = window.SHOPIFY_DATA.shop.country;
  const currency = window.SHOPIFY_DATA.shop.currency;

  const formatter = new Intl.NumberFormat(`${locale}-${country}`, {
    style: "currency",
    currencyDisplay: "narrowSymbol",
    currency,
  });

  return formatter.format(cents / 100);
}

export function parseDate(string?: string) {
  if (!string) return null;
  const date = new Date(string);
  return isNaN(date.getTime()) ? null : date;
}

export function normaliseId(id: string | number) {
  if (typeof id === "number") return id.toString();
  return id?.split("/")?.pop() ?? id;
}

export function hasIntersection({
  a1 = [],
  a2 = [],
  normalise = false,
}: {
  a1?: string[];
  a2?: string[];
  normalise?: boolean;
}) {
  const isNotComparingArrays = !Array.isArray(a1) || !Array.isArray(a2);
  const isNotComparingItems = a1.length === 0 || a2.length === 0;
  if (isNotComparingArrays || isNotComparingItems) return undefined;

  // Convert arrays to Sets for O(1) lookup
  const s1 = new Set(normalise ? a1.map(normaliseId) : a1);
  return a2.some((item) => s1.has(normalise ? normaliseId(item) : item));
}

export function isLoggedIn() {
  return window?.SHOPIFY_DATA?.customer?.loggedIn;
}
